// USER DATA
export const ADD_UDATA = "ADD_UDATA";

export const ADD_SIDE_BAR_SHOW = "ADD_SIDE_BAR_SHOW";
